<template>
  <div class="cust-container">
    <menuBar></menuBar>
    <div>
      <div class="banner">
        <img src="@/assets/images/whyChooseSCAD/banner.jpg" />
      </div>

      <div class="content">
        <div class="title" v-if="$i18n.locale === 'en'">
          <h1 class="title1" style="font-weight: 800">Why choose SCAD</h1>
          <h4 class="title2">
            At SCAD, creative education extends far beyond the classroom. 100+
            degree programs, an international learning environment,
            interdisciplinary study, and industry-connected experiences empower
            students to explore their passions, broaden their perspectives, and
            prepare for meaningful creative careers. From professional-level
            technology and real-world corporate assignments to executive
            mentors, personal career coaching, and a global alumni network, SCAD
            integrates career preparation into every stage of the student
            experience, helping creative potential become professional
            expertise.
          </h4>
        </div>

        <div class="title" v-if="$i18n.locale === 'zh'">
          <h1 class="title1" style="font-weight: 800">
            我选择 SCAD，让热爱成为事业
          </h1>
          <h4 class="title2">
            在SCAD，创意教育从不局限于课堂。100多个学位课程、国际化的学习环境、跨学科的课程体系，以及与行业紧密相连的实践机会，共同帮助学生探索热爱、拓展视野，并为未来的创意职业做好准备。从专业学习与真实企业项目，到驻校行业导师、一对一职业指导和全球校友网络，SCAD将职业发展融入学习的每个阶段，让每一份创意潜力都有机会转化为走向未来的专业实力。
          </h4>
        </div>

        <div class="menu-list">
          <el-row :gutter="0" class="menu-row">
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="menu-item">
                <div class="text1" style="color: #e13f8a">100+</div>
                <div class="text2" v-if="$i18n.locale === 'zh'">
                  学位项目 <br /><br />
                </div>
                <div class="text2" v-if="$i18n.locale === 'en'">
                  degree programs
                </div>

                <div class="readmore">
                  <a href="/Academic/" style="text-decoration: none">
                    <div class="readmore-btn">Read More</div>
                  </a>
                </div>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="menu-item">
                <div class="text1" style="color: #53acf0">30</div>

                <div class="text2" v-if="$i18n.locale === 'zh'">
                  STEM 认证专业 <br />（科学、技术、工程、数学相关领域）
                </div>
                <div class="text2" v-if="$i18n.locale === 'en'">
                  STEM programs
                </div>

                <div class="readmore">
                  <a href="/STEM/" style="text-decoration: none">
                    <div class="readmore-btn">Read More</div>
                  </a>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="0" class="menu-row">
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="menu-item">
                <div class="text1" style="color: #4aaf66">4</div>

                <div class="text2" v-if="$i18n.locale === 'zh'">全球校区</div>
                <div class="text2" v-if="$i18n.locale === 'en'">
                  global locations
                </div>
                <div class="readmore">
                  <a href="/locations/Atlanta" style="text-decoration: none">
                    <div class="readmore-btn">Read More</div>
                  </a>
                </div>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="menu-item">
                <div class="text1" style="color: #eda547">99%</div>
                <div class="text2" v-if="$i18n.locale === 'zh'">学生就业率</div>
                <div class="text2" v-if="$i18n.locale === 'en'">
                  alumni employment
                </div>

                <div class="readmore">
                  <div class="readmore-btn" @click="showVideo = true">
                    Read More
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>

          <!--<el-row :gutter="0" class="menu-row">-->
          <!--  <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">-->
          <!--    <div class="menu-item">-->
          <!--      <div class="text1" style="color: #aa58a0">XX</div>-->
          <!--      <div class="text2">industry partners</div>-->
          <!--    </div>-->
          <!--  </el-col>-->
          <!--  <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">-->
          <!--    <div class="menu-item">-->
          <!--      <div class="text1" style="color: #fcf25f">XX</div>-->
          <!--      <div class="text2">awards</div>-->
          <!--    </div>-->
          <!--  </el-col>-->
          <!--</el-row>-->
        </div>
      </div>
    </div>

    <transition name="ani-video">
      <div class="videoPlane" v-if="showVideo == true">
        <div class="videoBg" @click="showVideo = false"></div>
        <video
          src="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20220914/2022-23%20Creative%20Careers_CHINESE_subtitles-FNL.mp4"
          poster="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20220914/2022-23%20Creative%20Careers_CHINESE_subtitles-FNL.mp4?x-oss-process=video/snapshot,t_1500,m_fast"
          controls
        ></video>
      </div>
    </transition>

    <goTop></goTop>
    <custFooter></custFooter>
  </div>
</template>

<script>
import menuBar from "../../components/menuBar/index.vue";
import custFooter from "@/components/footer/Footer";
export default {
  metaInfo: {
    title: "SCAD", // set a title
  },
  name: "WhyChooseSCAD",
  components: {
    menuBar,
    custFooter,
  },
  data: function () {
    return {
      showVideo: false,
    };
  },
};
</script>

<style lang="less" scoped>
@import url(WhyChooseSCAD.less);

.ani-video-enter-active {
  transform: scale(0);
}
.ani-video-enter {
  transform: scale(0);
}
.ani-video-leave-active {
  transform: scale(0);
}
.ani-video-leave-to {
  transform: scale(0);
}
</style>
